export { OnlineIndicatorSize } from './online-indicator.component';
